import $$ from 'cmn-utils'
import {getUnitId} from "@/utils/deviceId2unitId"

const baseUrl = "/api/enterprise/alarm/";
export default {
    get: (params) => {
        const unitId=getUnitId(params.deviceId)
        params.unitId=unitId
        return $$.get(baseUrl + 'get', params)
    },
    list: (params) => {
        const unitId=getUnitId(params.deviceId)
        params.unitId=unitId
        Object.keys(params).map(key => {
            if (!params[key] || params[key] == 'null' || params[key] == 'undefined') delete params[key]
        })
        return $$.get(baseUrl + 'list', params)
    },



}